import React from "react"
import { recipes } from "../Constants/productListConstant"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import ContentPage from "../components/content-page"
import Meta from "../components/meta"
import Link from "gatsby-link"
import "../css/TempRecipe.css"
import ReactPixel from "react-facebook-pixel"
// import jsPDF from "jspdf"
let jsPDF

const StepsCard = ({ item }) => {
	return (
		<div className="recips__card">
			<div className="stepsNumber">
				{item.title}
			</div>
			<div className="stepsDetails">
				{item.subtitle}
			</div>
		</div>
	)
}

StepsCard.propTypes = {
	item: PropTypes.object
}

export class index extends React.Component {
	constructor (args) {
		super(args)
		this.state = {
			defaultStyle: {
				transition: `opacity ${400}ms ease-in-out`,
				opacity: 0,
			}
		}
	}
	componentDidMount () {
		ReactPixel.init("145006083100066")
		ReactPixel.track("ViewContent", location)
		try {
			jsPDF = require("jspdf")
			this.setState({
				loader: true
			})
		} catch (e) {
			console.error(e)
		}
		setTimeout(() => {
			this.setState({
				defaultStyle: {
					transition: `opacity ${400}ms ease-in-out`,
					opacity: 1,
				}
			})
		}, 500)
	}
	// downloadPDFFunction = (item) => {
	// 	let doc = new jsPDF()
	// 	doc.setFontSize(8)
	// 	doc.text(`Recipe : ${item.recipeName}`, 10, 10)
	// 	doc.text("Ingredients :", 10, 30)
	// 	item.ingredients.map((item, j) => {
	// 		doc.text(`${item.quantity} : ${item.description}`, 10, 40 + j * 10)
	// 	})
	// 	doc.addPage("a4", "portrait")
	// 	doc.text("Preparation :", 10, 30)
	// 	item.Preparation.map((item, i) => {
	// 		let strArr = doc.splitTextToSize(`${item.title} : ${item.subtitle}`, 190)
	// 		doc.text(strArr, 10, 40 + i * 15)
	// 	})
	// 	doc.save(`${item.recipeName}`)
	// }
	render () {
		const { item, location } = this.props
		const { defaultStyle } = this.state
		return (
			<ContentPage>
				<Meta title={item.title} image={item.logoUrl} description={`${item.title} | Bawa Masala Company Recipes`} location={location} />
				<div className="global_wrapper" style={defaultStyle}>
					<div className="TempRecipes_wrapper">
						<div className="TempRecipe">
							<div className="nav_bar">
								<Link to={`/recipes`}><span className="active">Recipes </span></Link>
								/
								<span className="item__name"> {item.title}</span>
							</div>
							<div className="headsection">
								<div className="row">
									<div className="col-md-4">
										<div className="recipe_heading">
											<span>
												<div className="recipe_title">{item.title}{" "}</div>
												<div className="vonvge">
													<div className={item.isVeg ? "green" : "red"}>
														<i className="fa fa-circle"></i>
													</div>
												</div>
											</span>
										</div>
										<div className="recipeTime">
											<div className="cookTime">
												<div className="cook_heading">Cook Time</div>
												<div className="cook_time">20</div>
											</div>
											<div className="cookTime">
												<div className="cook_heading">Prep Time</div>
												<div className="cook_time">5</div>
											</div>
											<div className="cookTime">
												<div className="cook_heading">Serves</div>
												<div className="cook_time">4-6</div>
											</div>
										</div>
										<div className="social">
											<div className="social_icons">
												<span className="icon">
													<a rel="noopener noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=http://bawamasalacompany.com${location.pathname}`} target="_blank" className=""><i className="fa fa-facebook"></i></a>
												</span>
												<span className="icon">
													<a rel="noopener noreferrer" href="https://www.instagram.com/bawamasalacompany/" target="_blank" className=""><i className="fa fa-instagram"></i></a>
												</span>
												<span className="icon">
													<a rel="noopener noreferrer" href={`https://twitter.com/intent/tweet?url=http://bawamasalacompany.com${location.pathname}`} target="_blank" className=""><i className="fa fa-twitter"></i></a>
												</span>
												<span className="icon">
													<a download={`${item.recipeDown}`} href={`${item.recipeDown}`} title={`${item.recipeDown}`} target="_blank"><i className="fa fa-download"></i></a>
												</span>
											</div>
										</div>
									</div>
									<div className="col-md-8">
										<div className="image_section">
											<div className="recipe_image ">
												<embed src={item.logoUrl} alt={item.title} className="" />
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="time">
								<div className="row">
									<div className="col-md-12">
										<div className="vonvge1">
											<div className={item.isVeg ? "green" : "red"}>
												<i className="fa fa-circle"></i>
											</div>
										</div>
										<div className="recipeTime1">
											<div className="cookTime1">
												<div className="cook_heading1">Cook Time</div>
												<div className="cook_time1">20</div>
											</div>
											<div className="cookTime1">
												<div className="cook_heading1">Prep Time</div>
												<div className="cook_time1">5</div>
											</div>
											<div className="cookTime1">
												<div className="cook_heading1">Serves</div>
												<div className="cook_time1">4-6</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="mid_section">
								<div className="social1">
									<div className="social_icons1">
										<span className="icon1">
											<a rel="noopener noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=http://bawamasalacompany.com${location.pathname}`} target="_blank" className=""><i className="fa fa-facebook"></i></a>
										</span>
										<span className="icon1">
											<a rel="noopener noreferrer" href="https://www.instagram.com/bawamasalacompany/" target="_blank" className=""><i className="fa fa-instagram"></i></a>
										</span>
										<span className="icon1">
											<a rel="noopener noreferrer" href={`https://twitter.com/intent/tweet?url=http://bawamasalacompany.com${location.pathname}`} target="_blank" className=""><i className="fa fa-twitter"></i></a>
										</span>
										<span className="icon1">
											<a download={`${item.recipeDown}`} href={`${item.recipeDown}`} title={`${item.recipeDown}`} target="_blank"><i className="fa fa-download"></i></a>
										</span>
									</div>
								</div>
								<div className="row">
									<div className="col-md-4">
										<div className="ingredients_content">
											<div className="ing_heading">INGREDIENTS</div>
											<div className="ingredients_section">
												<div className="ingr_detail">
													<table >
														<tbody>
															{item.ingredients.map((item, i) => {
																return (
																	<tr key={i}>
																		<td>{item.quantity}</td>
																		<td>{item.description}</td>
																	</tr>)
															})}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-8">
										<div className="pre_section">
											<div className="pre_heading">PREPARATION</div>
											<div className="pre_details">
												{item.Preparation.map((item, i) => {
													return (<div key={i}>
														<StepsCard item={item} />
													</div>)
												})}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ContentPage>
		)
	}
}

index.propTypes = {
	item: PropTypes.object,
	defaultStyle: PropTypes.object,
	location: PropTypes.object
}

const mapDispatchToProps = {
}

const mapStateToProps = (state, ownProps) => {
	// console.log("ownProps", ownProps)
	// debugger;
	const { location } = ownProps
	const title = location.pathname.split("/")[2]
	let content = {}
	Object.keys(recipes).map((key, i) => {
		if (recipes[key].title.replace(/ /g, "") === title) {
			content = recipes[key]
		}
		return recipes[key]
	})
	return {
		...ownProps,
		item: content
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(index)



// WEBPACK FOOTER //
// ./src/template/TempRecipe.js